<template>
	<div class="container">
		<div class="banner">
			<img :src="activity.imageurl" />
		</div>
		<div class="title">
			<div>{{activity.title}}</div>
			<img @click="Fabulous" v-if="!isFabulous" src="../assets/zanno.png" />
			<img @click="cancel" v-if="isFabulous" src="../assets/zanyes.png" />
		</div>
		<div class="list">
			<div class="list_container" @click="appointment">
				<img src="../assets/activities_time.png" />
				<div>{{activity.starttime}}--{{activity.endtime}}</div>
			</div>
			<div class="list_container">
				<img src="../assets/activities_dizhi.png" />
				<div>{{activity.address}}</div>
			</div>
			<div class="list_container">
				<div v-if="people_num==''"></div>
				<div v-else="">剩余票数：{{people_num}}</div>
			</div>
		</div>
		<div class="activities">
			<div class="activities_title">活动详情</div>
			<div class="activities_content" v-html="activity.detail"></div>
		</div>
		<div class="appointment">
			<div class="appointment_cli" @click="appointment">立即预约</div>
		</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<div @click="determine">确定</div>
			</div>
		</div>
		<div v-show="getTime_black_show" class="getTime_black" @click="getTime_black">

		</div>
		<div v-show="getTime_show" class="getTime">
			<div class="getTime_appointment">
				<div>请选择预约门票时间</div>
			</div>
			<Calendar v-on:choseDay="clickDay"></Calendar>
			<div v-if="registrationEnd!=''" class="registrationEnd">
				{{registrationEnd}}
			</div>
			<ul v-else="" class="personal_site">
				<li v-if="item.ticketnums>0" :class="activeClass==index?'personal_site_red':'personal_site_white'" v-for="(item,index) in details" @click="changeli_site(item,index)">
					<div>{{item.name}}票</div>
					<div>(余票：<span>{{item.ticketnums}}</span>)</div>
				</li>
				<li v-else="" class="personal_site_white">
					<div>{{item.name}}票</div>
					<div>(已售完)</div>
				</li>
			</ul>
			<div class="personal_btn" @click="appointment_cli">立即预约</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	import Calendar from 'vue-calendar-component';
	export default {
		name: 'DetailsActivities',
		data() {
			return {
				taid: "",
				activity: [],
				time: "请选择预约时间",
				Scene: "请选择场次",
				opentimecustomlist: [],
				details: [],
				people_num: "",
				success: false,
				success_img: false,
				success_text: "",
				paragraphid: "",
				getTime_black_show: false,
				getTime_show: false,
				month: "",
				details: [],
				activeClass: -1,
				appointmenttime: "",
				getTime_show: false,
				getTime_black_show: false,
				site_name: "",
				paragraphid: "",
				registrationEnd: "",
				today: "",
				baseUrlOne: "",
				access_token: "",
				isFabulous: "",
				outtime:"",
				thisTime:""
			}
		},
		components: {
			Calendar
		},
		methods: {
			Fabulous() {
				var that = this;
				wclient.ajax({
					type: "GET",
					url: that.baseUrlOne + '/ajax?ugi=comment&action=userCommentFabulous',
					dataType: "json",
					async: true,
					data: {
						access_token: that.access_token,
						commentid: that.taid
					},
					success: function(data) {
						wclient.view.hideLoading();
						if(data.code == 'A00006') {
							wclient.ajax({
								type: "GET",
								url: that.baseUrlOne + '/ajax?ugi=comment&action=checkUserIsFabulous',
								dataType: "json",
								async: true,
								data: {
									access_token: that.access_token,
									commentid: that.taid
								},
								success: function(data) {
									wclient.view.hideLoading();
									if(data.code == 'A00006') {
										that.isFabulous = data.isFabulous;
									}

								}
							});
						}

					}
				});
			},
			cancel() {
				var that = this;
				wclient.ajax({
					type: "GET",
					url: that.baseUrlOne + '/ajax?ugi=comment&action=userCommentFabulous',
					dataType: "json",
					async: true,
					data: {
						access_token: that.access_token,
						commentid: that.taid
					},
					success: function(data) {
						wclient.view.hideLoading();
						if(data.code == 'A00006') {
							wclient.ajax({
								type: "GET",
								url: that.baseUrlOne + '/ajax?ugi=comment&action=checkUserIsFabulous',
								dataType: "json",
								async: true,
								data: {
									access_token: that.access_token,
									commentid: that.taid
								},
								success: function(data) {
									wclient.view.hideLoading();
									if(data.code == 'A00006') {
										that.isFabulous = data.isFabulous;
									}

								}
							});
						}

					}
				});
			},
			select_change() {
				var that = this;
				for(var i = 0; i < that.opentimecustomlist.length; i++) {
					if(that.time == that.opentimecustomlist[i].time) {
						that.details = that.opentimecustomlist[i].details;
					}
				}
			},
			getTime_black() {
				var that = this;
				that.getTime_show = false;
				that.getTime_black_show = false;
				var mo = function(e) {
					e.preventDefault();
				};
				document.body.style.overflow = ''; //出现滚动条
				document.removeEventListener("touchmove", mo, false);
			},
			selectScene() {
				var that = this;
				for(var i = 0; i < that.details.length; i++) {
					if(that._data.Scene == that.details[i].time) {
						that.people_num = that.details[i].ticketnums;
						that.paragraphid = that.details[i].paragraphid;
					}
				}
			},
			clickDay(data) {
				var that = this;
				that.activeClass = -1;
				var today = new Date().getTime().toString().substring(0, 5);
				that.year = data.split("/")[0];
				that.month = data.split("/")[1];
				that.day = data.split("/")[2];
				if(that.month < 10) {
					that.month = "0" + that.month
				}
				if(that.day < 10) {
					that.day = "0" + that.day
				}
				var today_cli = that.year + "-" + that.month + "-" + that.day;
				if(new Date(that.today).getTime().toString() > new Date(today_cli).getTime().toString()) {
					that.registrationEnd = '活动报名已经结束';
				} else {
					for(var i = 0; i < that.opentimecustomlist.length; i++) {
						if(today_cli == that.opentimecustomlist[i].time) {
							that.details = that.opentimecustomlist[i].details;
							that.appointmenttime = that.opentimecustomlist[i].time;
							that.registrationEnd = "";
							if(that.opentimecustomlist[i].status == '0') {
								that.registrationEnd = '闭馆';
							}
							return;
						} else {
							that.registrationEnd = '活动报名还未开始';
						}
					}
				}

			},
			changeli_site(item, index) {
				var that = this;
				that.activeClass = index;
				that.site_name = item.name;
				that.paragraphid = item.paragraphid;
				that.outtime = item.outtime;
			},
			appointment_cli() {
				var that = this;
				var timer=new Date();
				var year=timer.getFullYear();
				var month=timer.getMonth()+1;
				var day=timer.getDate();
				var hour=timer.getHours();
				var minutes=timer.getMinutes();
				var thisSecond=parseInt(hour)*60*60+parseInt(minutes)*60;
				var cliSecond=parseInt(that.outtime.split(':')[0])*60*60+parseInt(that.outtime.split(':')[1])*60;
				if(that.activeClass == -1) {
					that.success = true;
					that.success_img = false;
					that.success_text = '请选择预约时间';
				}else if(that.appointmenttime==that.today&&parseInt(thisSecond)>parseInt(cliSecond)){
					that.success = true;
					that.success_img = false;
					that.success_text = '您所选日期不能预约，请重新选择！';
				} else {
					var mo = function(e) {
						e.preventDefault();
					};
					document.body.style.overflow = ''; //出现滚动条
					document.removeEventListener("touchmove", mo, false);
					that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=90dec8d3b36e412495465b49a0f02fb0&sponsorid=a0df565fe509435eba413105fc9a006c', {

						})
						.then(function(res) {
							if(res.data.code == 'A00006') {
								sessionStorage.removeItem("ticketcodelist");
								sessionStorage.setItem("imageurl", that.activity.imageurl);
								sessionStorage.setItem("title", that.activity.title);
								sessionStorage.setItem("site_name", that.site_name);
								sessionStorage.setItem("appointmenttime", that.appointmenttime);
								sessionStorage.setItem("paragraphid", that.paragraphid);
								sessionStorage.setItem("summary", that.activity.summary);
								that.$router.push({
									name: 'FillInformation'
								});
							}
						})
						.catch(function(err) {
							console.log(err);
						});
				}
			},
			appointment() {
				var that = this;
				that.getTime_show = true;
				that.getTime_black_show = true;
				var mo = function(e) {
					e.preventDefault();
				};
				document.body.style.overflow = 'hidden';
				document.addEventListener("touchmove", mo, false)
			},
			determine() {
				var that = this;
				that.success = false;

			}
		},
		mounted() {
			var that = this;
			that.taid = sessionStorage.getItem("taid");
			that.access_token = localStorage.getItem('access_token');
			let time = new Date();
			that.month = time.getMonth() + 1;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "https://www.xiangshan1949.cn";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "http://xs.weapi.org";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			that.baseUrlOne = baseUrlOne;
			wclient.view.showLoading();
			that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityDetails&moduleid=TICKETS&taid=' + that.taid, {

				})
				.then(function(res) {
					wclient.view.hideLoading();
					if(res.data.code == 'A00006') {
						that.activity = res.data.activity;
						that.$http({
							method: "get",
							url: that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticket&action=bookingTime&moduleid=TICKETS&taid=' + that.taid,
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							}
						}).then(res => {
							that.opentimecustomlist = res.data.opentimecustomlist;
							var timer = new Date();
							var year = timer.getFullYear();
							var month = timer.getMonth() + 1;
							var day = timer.getDate();
							if(month < 10) {
								month = "0" + month
							}
							if(day < 10) {
								day = "0" + day
							}
							that.today = year + "-" + month + "-" + day;
						}).catch(res => {
							console.log('发送Ajax请求,请求失败', res);
						});
					}
				})
				.catch(function(err) {
					console.log(err);
				});
			wclient.ajax({
				type: "GET",
				url: that.baseUrlOne + '/ajax?ugi=comment&action=checkUserIsFabulous',
				dataType: "json",
				async: true,
				data: {
					access_token: that.access_token,
					commentid: that.taid
				},
				success: function(data) {
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						that.isFabulous = data.isFabulous;
					}

				}
			});
		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	
	.banner {
		width: 100%;
		margin: 0 auto;
	}
	
	.title {
		width: 90%;
		margin: 0 auto;
		line-height: 30px;
		font-weight: bold;
		color: rgba(24, 24, 24, 1);
		background: white;
		padding: 10px 5%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.title img {
		width: 7%;
	}
	
	.list {
		width: 100%;
		margin: 0 auto;
		background: white;
	}
	
	.list_container {
		width: 100%;
		border-top: 1px solid rgba(206, 206, 206, 1);
		height: 50px;
		line-height: 50px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 14px;
		font-weight: 400;
		color: rgba(159, 159, 159, 1);
	}
	
	.list_container img {
		width: 20px;
		height: auto;
	}
	
	.list_container:nth-child(3) {
		font-weight: bold;
		color: rgba(114, 114, 114, 1);
		text-indent: 25px;
	}
	
	.list_container img {
		width: 4%;
		margin-left: 20px;
		margin-right: 15px;
	}
	
	select {
		background: white !important;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border: none;
		outline: none;
		font-size: 16px;
		color: #B1B1B1;
		width: 95%;
		font-size: 14px;
	}
	
	.activities {
		width: 90%;
		margin: 10px auto 90px;
		background: white;
		padding: 20px 5%;
	}
	
	.activities_title {
		width: 100%;
		font-weight: bold;
		color: rgba(44, 44, 44, 1);
	}
	
	.activities_content {
		width: 100%;
		margin: 5px auto 0;
		font-weight: 400;
		color: rgba(159, 159, 159, 1);
		font-size: 14px;
		line-height: 25px;
	}
	
	.activities_content>>>p {
		font-size: 16px !important;
	}
	
	.activities_content>>>p img {
		width: 100%;
		height: auto;
	}
	
	.appointment {
		width: 100%;
		margin: 0 auto;
		background: white;
		padding: 20px 0;
		border-top: 1px solid rgba(232, 232, 232, 1);
		position: fixed;
		left: 0;
		bottom: 0;
	}
	
	.appointment_cli {
		width: 70%;
		margin: 0 auto;
		line-height: 45px;
		text-align: center;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		border-radius: 62px;
		color: rgba(254, 254, 254, 1);
		font-size: 15px;
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 25%;
		margin-left: 37%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 90%;
		color: black;
		font-size: 20px;
		font-weight: 600;
		text-align: center;
		margin: 20px auto 0;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: #A4A4A4;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
	
	.getTime_black {
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
	}
	
	.getTime {
		width: 90%;
		padding: 0 5% 25px;
		background: rgba(246, 246, 246, 1);
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 11;
	}
	
	>>>.wh_container {
		width: 100%;
		border-radius: 50px;
	}
	
	>>>.wh_jiantou1 {
		border-top: 2px solid rgba(70, 70, 70, 1) !important;
		border-left: 2px solid rgba(70, 70, 70, 1) !important;
	}
	
	>>>.wh_jiantou2 {
		border-top: 2px solid rgba(70, 70, 70, 1) !important;
		border-left: 2px solid rgba(70, 70, 70, 1) !important;
		transform: rotate(130deg) !important;
	}
	
	>>>.wh_top_changge li {
		color: rgba(70, 70, 70, 1) !important;
	}
	
	>>>.wh_content_all {
		background: white !important;
	}
	
	>>>.wh_content_item {
		color: rgba(70, 70, 70, 1) !important;
	}
	
	>>>.wh_content_item .wh_chose_day {
		background: rgba(222, 75, 67, 1) !important;
		color: white !important;
	}
	
	>>>.wh_item_date {
		background: white !important;
	}
	
	.getTime_appointment {
		width: 100%;
		display: flex;
		justify-content: space-between;
		line-height: 50px;
		color: rgba(70, 70, 70, 1);
	}
	
	.personal_time {
		border-radius: 15px;
		float: left;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: white;
	}
	
	.personal_time img {
		width: 10px;
	}
	
	.registrationEnd {
		width: 100%;
		line-height: 72px;
		text-align: center;
		margin-top: 30px;
	}
	
	.personal_site {
		width: 100%;
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
	}
	
	.personal_site_white {
		float: left;
		width: 47%;
		height: 62px;
		background: url(../assets/site_white.png) center center no-repeat;
		background-size: contain;
		padding-top: 10px;
		color: #ACB2B6;
	}
	
	.personal_site_red {
		float: left;
		width: 47%;
		height: 62px;
		background: url(../assets/site_red.png) center center no-repeat;
		background-size: contain;
		padding-top: 10px;
		color: #E40404;
	}
	
	.personal_site>li div {
		width: 100%;
		float: left;
		text-align: center;
		line-height: 20px;
	}
	
	.personal_site>li div:nth-child(1) {
		font-size: 14px;
		margin-top: 5px;
		font-weight: 500;
	}
	
	.personal_site>li div:nth-child(2) {
		font-size: 12px;
	}
	
	.personal_btn {
		width: 75%;
		margin: 50px auto 0;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		color: rgba(254, 254, 254, 1);
		line-height: 45px;
		text-align: center;
		font-size: 14px;
		border-radius: 40px;
	}
</style>


// WEBPACK FOOTER //
// src/components/detailsActivities.vue